import axios from 'axios';

import ApiCore from '../Utils/ApiCore';
import ApiPathMgr from '../Utils/ApiPathMgr';
import PublicApiConfig from '../Utils/PublicApiConfig';

import AgentsApi from './agents/AgentsApi';
import BlogApi from './blog/BlogApi';
import GeoApi from './geo/GeoApi';
import MailApi from './mail/MailApi';
import PropertiesApi from './properties/PropertiesApi';
import PlaceMagazineApi from './place-magazine/PlaceMagazineApi';

export { PublicApiConfig };

export default class PublicApi {
    constructor(publicApiCfg, authToken) {
        if (!(publicApiCfg instanceof PublicApiConfig)) {
            publicApiCfg = new PublicApiConfig(publicApiCfg);
        }

        this.apiConfig = publicApiCfg;

        this.CORE = new ApiCore(publicApiCfg);
        this.ApiPathMgr = new ApiPathMgr();

        this.Agents = new AgentsApi(this);
        this.Blog = new BlogApi(this);
        this.Geo = new GeoApi(this);
        this.Mail = new MailApi(this);
        this.Properties = new PropertiesApi(this);
        this.PlaceMagazine = new PlaceMagazineApi(this);
    }

    getRootSitemap() {
        return this.CORE.getXML(PublicApi.SitemapPath);
    }

    getStaticSitemap(urls) {
        return this.CORE.getXML(PublicApi.StaticSitemapPath, urls);
    }
}

PublicApi.SitemapPath = '/api/sitemap';
PublicApi.StaticSitemapPath = '/api/sitemap/static';



// WEBPACK FOOTER //
// ./src/PublicApi/index.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/index.js